"use strict";

var e = require("./_commonjsHelpers-f10b257f.js"),
  t = e.createCommonjsModule(function (e) {
    e.exports = function (e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  r = e.getDefaultExportFromCjs(t);
exports._taggedTemplateLiteral = r;